import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout({ children, hideFooter }) {
  return (
    <div className="grain min-h-screen flex flex-col">
      <Navbar />
      <main className="relative z-10 flex-1">{children}</main>
      {!hideFooter && <Footer />}
    </div>
  );
}
